module.exports = __webpack_public_path__ + "static/media/g-10.aef2f70a.jpg";